export default __webpack_public_path__ + "static/media/bewerber-first-mirror.b48bda67.png";